var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-toolbar',{attrs:{"outlined":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$vuetify.lang.t("$vuetify.site['" + _vm.page + "']")))]),_c('v-spacer'),_vm._v(" /"+_vm._s(_vm.page)+" ")],1),_c('br'),(_vm.page == 'all')?_c('All'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }